import React from 'react';
import { Edit3, ChevronDown } from 'lucide-react';

export default function ExpiryDisplay({ styles, value, onOpen }) {
  return (
    <div
      className={styles.icdDisplay}
      role="button"
      tabIndex={0}
      onClick={onOpen}
      onKeyDown={e => (e.key === 'Enter' || e.key === ' ') && onOpen()}
      aria-label="Open Expiry editor"
    >
      <input
        type="text"
        value={value}
        readOnly
        className={`${styles.icdReadonlyInput} ${styles.tallReadonlyInput}`}
      />
      <button
        type="button"
        className={styles.icdEditInline}
        onClick={e => {
          e.stopPropagation();
          onOpen();
        }}
        aria-label="Edit Expiry"
      >
        <Edit3 size={16} />
      </button>
      <span className={styles.icdCaret} aria-hidden="true">
        <ChevronDown size={16} />
      </span>
    </div>
  );
}
